export default __webpack_public_path__ + "static/media/ic-down_Primary1.5fafcb7c.svg";